const clean = (term) => term.replace(/[^\w]/g, '')

const highlight = (needles = '', haystack) =>
  haystack &&
  needles
    .split(' ')
    .map(clean)
    .filter((value) => !!value)
    .reduce(
      (newHaystack, needle) =>
        newHaystack.replace(
          new RegExp(needle, 'gi'),
          (str) => `<0000000>${str}</0000000>`
        ),
      haystack
    )
    .replace(/0000000/g, 'strong')

export default highlight
